import { ArrowUpRight } from "lucide-react";
import Photo from "./Photo";
import { Title, Kicker } from "./bits";
import { T, UNIVERSES } from "./content";

export default function Registre({ lang }) {
  const t = T[lang];
  return (
    <section className="section" id="univers" data-testid="section-univers">
      <div className="container">
        <div className="section-head reveal">
          <Kicker withDash>{t.universKicker}</Kicker>
          <Title parts={t.universTitle} tag="h2" />
        </div>

        <div className="uni-grid">
          {UNIVERSES.map((u) => {
            const name = lang === "fr" ? u.nameFr : u.nameEn;
            const desc = lang === "fr" ? u.descFr : u.descEn;
            return (
              <article className="uni-card tile reveal" key={u.num} data-testid={`univers-row-${u.num}`}>
                <div className="uni-card__media">
                  <Photo slug={u.slug} label={name} className="photo-img" />
                </div>
                <span className="uni-card__num">{u.num}</span>
                <span className="uni-card__arrow">
                  <ArrowUpRight size={22} strokeWidth={1.2} />
                </span>
                <div className="uni-card__body">
                  <h3 className="uni-card__name">{name}</h3>
                  <p className="uni-card__desc">{desc}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
